// Giải pháp tùy chỉnh cho Discount Code trong Cart Drawer
// Dựa trên cấu trúc HTML chính xác của theme
document.addEventListener('DOMContentLoaded', function() {
  // Function để thiết lập sự kiện cho discount code
  function setupCartDiscountLogic() {
    console.log("Setting up cart discount logic...");
    
    // Tìm form discount bằng các selectors chính xác từ HTML
    const discountDetails = document.querySelector('details.ks-cart-discount-form');
    const discountForm = document.querySelector('ks-cart-discount-form');
    const discountInput = document.querySelector('.field__input[placeholder="Enter your discount code"]');
    const applyButton = document.querySelector('button[data-text="Apply"]');
    const checkoutButton = document.querySelector('button.cart__checkout-button');
    
    console.log("Elements found:", {
      discountDetails: !!discountDetails,
      discountForm: !!discountForm,
      discountInput: !!discountInput,
      applyButton: !!applyButton,
      checkoutButton: !!checkoutButton
    });
    
    // Nếu không tìm thấy các phần tử, thử lại sau 500ms
    // (Có thể cart drawer chưa hoàn toàn được tải)
    if (!discountInput || !checkoutButton) {
      console.log("Elements not found, will try again soon");
      setTimeout(setupCartDiscountLogic, 500);
      return;
    }
    
    // Xử lý sự kiện khi nhập discount code
    discountInput.addEventListener('input', function() {
      const code = this.value.trim();
      if (code) {
        console.log("Saving discount code:", code);
        localStorage.setItem('shopify_discount_code', code);
      }
    });
    
    // Xử lý nút Apply
    if (applyButton) {
      // Đảm bảo chỉ add event listener một lần
      if (!applyButton.hasAttribute('data-discount-handler')) {
        applyButton.setAttribute('data-discount-handler', 'true');
        
        applyButton.addEventListener('click', function(e) {
          const code = discountInput.value.trim();
          if (code) {
            console.log("Apply clicked, saving code:", code);
            localStorage.setItem('shopify_discount_code', code);
            
            // Redirect đến checkout với discount code
            e.preventDefault();
            e.stopPropagation();
            
            // Delay redirect để cho phép sự kiện click xảy ra trước
            setTimeout(function() {
              redirectToCheckoutWithDiscount(code);
            }, 100);
            
            return false;
          }
        });
      }
    }
    
    // Xử lý nút Checkout
    if (!checkoutButton.hasAttribute('data-discount-handler')) {
      checkoutButton.setAttribute('data-discount-handler', 'true');
      
      checkoutButton.addEventListener('click', function(e) {
        const code = discountInput.value.trim() || localStorage.getItem('shopify_discount_code');
        
        if (code) {
          console.log("Checkout clicked, using code:", code);
          e.preventDefault();
          e.stopPropagation();
          
          // Redirect đến checkout với discount code
          redirectToCheckoutWithDiscount(code);
          return false;
        }
      });
    }
  }
  
  // Function để redirect đến checkout với discount code
  function redirectToCheckoutWithDiscount(code) {
    console.log("Redirecting to checkout with discount:", code);
    
    // Tạo form động để submit
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart';
    form.style.display = 'none';
    
    // Thêm các trường
    // Thêm field checkout
    const checkoutField = document.createElement('input');
    checkoutField.type = 'hidden';
    checkoutField.name = 'checkout';
    form.appendChild(checkoutField);
    
    // Thêm field discount code
    const discountField = document.createElement('input');
    discountField.type = 'hidden';
    discountField.name = 'discount';
    discountField.value = code;
    form.appendChild(discountField);
    
    // Thêm form vào body và submit
    document.body.appendChild(form);
    console.log("Submitting form with discount code");
    form.submit();
  }
  
  // Thiết lập logic khi trang tải
  setupCartDiscountLogic();
  
  // Theo dõi khi cart drawer được mở (sử dụng MutationObserver)
  const bodyObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Kiểm tra xem cart drawer có được thêm vào không
        const cartDrawerAdded = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && (
            node.classList?.contains('ks-cart-drawer-wrapper') ||
            node.querySelector?.('.ks-cart-drawer-wrapper')
          );
        });
        
        if (cartDrawerAdded) {
          console.log("Cart drawer detected in DOM");
          setupCartDiscountLogic();
        }
      } else if (mutation.type === 'attributes' && 
                (mutation.target.classList?.contains('ks-cart-drawer-wrapper') || 
                 mutation.target.querySelector?.('.ks-cart-drawer-wrapper'))) {
        console.log("Cart drawer attributes changed");
        setupCartDiscountLogic();
      }
    }
  });
  
  // Bắt đầu theo dõi body để phát hiện cart drawer
  bodyObserver.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class']
  });
  
  // Bắt sự kiện khi cart drawer được mở
  document.addEventListener('click', function(e) {
    // Kiểm tra xem người dùng có click vào cart icon hoặc cart link
    if (e.target.closest('a[href="/cart"]') || 
        e.target.closest('button[aria-controls="cart-drawer"]') ||
        e.target.closest('.js-drawer-open-cart')) {
      console.log("Cart trigger clicked");
      setTimeout(setupCartDiscountLogic, 500);
    }
  });
});